import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { BsFileImage, BsFilePdf, BsFilePlay } from 'react-icons/bs';
import './CompactToolCard.css';

const CompactToolCard = ({ title, fromFormat, toFormat, customLink, iconType = 'image' }) => {
  const linkTo = customLink || `/image-converter?from=${fromFormat}&to=${toFormat}`;
  
  // Determine which icon to use
  const getIcon = () => {
    if (iconType === 'pdf') {
      return <BsFilePdf />;
    } else if (iconType === 'video') {
      return <BsFilePlay />;
    }
    return <BsFileImage />;
  };
  
  return (
    <Link 
      to={linkTo}
      style={{ textDecoration: 'none' }}
    >
      <motion.div
        className="compact-tool-card"
        whileHover={{ y: -4, scale: 1.02 }}
        transition={{ type: 'spring', stiffness: 300, damping: 20 }}
      >
        <motion.div 
          className="compact-tool-icon"
          whileHover={{ rotate: [0, -5, 5, 0], scale: 1.1 }}
          transition={{ duration: 0.4 }}
        >
          {getIcon()}
        </motion.div>
        <span className="compact-tool-title">{title}</span>
      </motion.div>
    </Link>
  );
};

export default CompactToolCard;
